<header class="hero">
  <div class="wrap">
    <p class="eyebrow" i18n="@@standortPage.hero.eyebrow">Standort-Rechner</p>
    <h1 i18n="@@standortPage.hero.h1">Lohnt sich Ihre marktbox an diesem Platz? <mark>Rechnen Sie es aus.</mark></h1>
    <p class="lead" i18n="@@standortPage.hero.lead">
      Beschreiben Sie Ihren geplanten Standort in einfachen Kategorien und erhalten Sie einen Score,
      einen realistischen Umsatzkorridor und Ihre zwei größten Hebel – inklusive Break-even. In unter
      einer Minute.
    </p>
    <div class="cta-row">
      <a class="btn" href="#rechner" (click)="scrollToAnchor($event, 'rechner')" i18n="@@standortPage.hero.cta1">Standort jetzt berechnen</a>
      <a class="btn btn--outline" [routerLink]="['/', links.guide, guideLocationPath]" i18n="@@standortPage.hero.cta2">Zum ausführlichen Standort-Guide</a>
    </div>
    <div class="trust"><span class="dot"></span> <ng-container i18n="@@standortPage.hero.trust">Auf Basis von <b>über 450&nbsp;Automaten</b> im Feld</ng-container></div>
  </div>
</header>

<nav class="subnav">
  <div class="wrap">
    <a href="#rechner" (click)="scrollToAnchor($event, 'rechner')" i18n="@@standortPage.subnav.rechner">Rechner</a>
    <a href="#versorgungsluecke" (click)="scrollToAnchor($event, 'versorgungsluecke')" i18n="@@standortPage.subnav.score">So liest sich Ihr Score</a>
    <a href="#typen" (click)="scrollToAnchor($event, 'typen')" i18n="@@standortPage.subnav.typen">Standorttypen</a>
    <a href="#filiale" (click)="scrollToAnchor($event, 'filiale')" i18n="@@standortPage.subnav.filiale">Vor dem eigenen Laden</a>
    <a href="#faktoren" (click)="scrollToAnchor($event, 'faktoren')" i18n="@@standortPage.subnav.faktoren">Harte Faktoren</a>
    <a href="#recht" (click)="scrollToAnchor($event, 'recht')" i18n="@@standortPage.subnav.recht">Rechtliches</a>
    <a href="#finden" (click)="scrollToAnchor($event, 'finden')" i18n="@@standortPage.subnav.finden">Standort finden</a>
    <a href="#flaeche" (click)="scrollToAnchor($event, 'flaeche')" i18n="@@standortPage.subnav.flaeche">Flächengeber</a>
  </div>
</nav>

<section class="band" id="rechner">
  <div class="wrap">
    <app-standort-rechner></app-standort-rechner>
  </div>
</section>

<section class="band band--teal">
  <div class="wrap">
    <div class="pullquote">
      <p class="mark" i18n="@@standortPage.quote.mark">Aus Erfahrung</p>
      <p class="big" i18n="@@standortPage.quote.big">Der richtige Standort ist selten der <em>erste</em>.</p>
      <p i18n="@@standortPage.quote.text">
        Kaum ein Betreiber trifft ihn auf Anhieb. Wer bereit ist, seinen Automaten ein zweites oder
        drittes Mal umzustellen, findet fast immer den einen, der wirklich für ihn läuft. Ein schwacher
        Score ist deshalb kein Nein – nur ein Hinweis, weiterzusuchen.
      </p>
    </div>
  </div>
</section>

<section class="band band--white" id="versorgungsluecke">
  <div class="wrap">
    <p class="sec-label"><span class="n">01</span> <ng-container i18n="@@standortPage.sec1.label">So liest sich Ihr Score</ng-container></p>
    <h2 i18n="@@standortPage.sec1.h2">Die Versorgungslücke entscheidet</h2>
    <div class="prose">
      <p i18n="@@standortPage.sec1.p1">
        Damit Ihr Ergebnis oben nicht nur eine Zahl bleibt, hier die Logik dahinter in Kurzform –
        ausführlicher steht alles im <a [routerLink]="['/', links.guide, guideLocationPath]">Standort-Guide</a>. Ein
        Verkaufsautomat konkurriert nicht um Aufmerksamkeit in der Fußgängerzone. Er verkauft dann gut,
        wenn er eine <strong>Nachfrage bedient, die sonst niemand bedient</strong>.
      </p>
    </div>
    <div class="thesis">
      <div class="kicker" i18n="@@standortPage.sec1.kicker">Die Kernthese</div>
      <p i18n="@@standortPage.sec1.these">
        Was den Umsatz einer marktbox bestimmt, ist nicht die Lage im klassischen Sinn, sondern die
        <strong>Versorgungslücke</strong>. Ein Automat an einer Landstraße ohne Supermarkt im Umkreis
        schlägt einen Automaten in bester Innenstadtlage.
      </p>
    </div>
    <div class="prose">
      <p i18n="@@standortPage.sec1.p2">
        Der stärkste Einzelfaktor ist die <strong>Entfernung zum nächsten Lebensmittelhandel</strong>.
        Wo abends, sonntags oder in einem kleinen Ort ohne Supermarkt kein Laden mehr offen hat, wird
        Ihr Automat zur nächstbesten Lösung – und macht Umsatz, der ohne Sie gar nicht stattfinden würde.
      </p>
    </div>
    <div class="nextstep">
      <div class="ic">→</div>
      <div class="tx" i18n="@@standortPage.sec1.nextstep"><b>Ihr nächster Schritt:</b> Messen Sie die Luftlinie von Ihrem Wunschstandort zum
        nächsten Supermarkt. Über 5 km? Sehr gutes Zeichen. Diese Zahl fließt oben in den Rechner ein.</div>
    </div>
  </div>
</section>

<section class="band" id="typen">
  <div class="wrap">
    <p class="sec-label"><span class="n">02</span> <ng-container i18n="@@standortPage.sec2.label">Standorttypen</ng-container></p>
    <h2 i18n="@@standortPage.sec2.h2">Typen im Vergleich – mit Umsatzkorridoren</h2>
    <div class="prose"><p i18n="@@standortPage.sec2.intro">Konkrete Typen statt Frequenz-Ratschläge. Orientierungswerte pro Monat für einen
      gut sortierten Automaten – der tatsächliche Umsatz hängt an Sortiment, Preisen und Versorgungslücke.</p></div>
    <div class="types">
      <div class="type"><span class="tag mid" i18n="@@standortPage.tag.solide">Solide</span><h4 i18n="@@standortPage.typ.hof">Hofeinfahrt / eigener Betrieb</h4>
        <div class="corridor" i18n="@@standortPage.typ.hof.corridor">1.600 – 2.400 € / Monat</div>
        <p i18n="@@standortPage.typ.hof.text">Verlässlich mit Stammkundschaft; lebt von Wiederkäufern, weniger von Laufkundschaft.</p></div>
      <div class="type"><span class="tag hi" i18n="@@standortPage.tag.sehrGut">Sehr gut</span><h4 i18n="@@standortPage.typ.landstrasse">Landstraße / Ortsrand</h4>
        <div class="corridor" i18n="@@standortPage.typ.landstrasse.corridor">3.000 – 4.400 € / Monat</div>
        <p i18n="@@standortPage.typ.landstrasse.text">Der Klassiker mit großer Versorgungslücke. Halten muss möglich sein.</p></div>
      <div class="type"><span class="tag mid" i18n="@@standortPage.tag.solide2">Solide</span><h4 i18n="@@standortPage.typ.wohn">Wohngebiet / Ortsmitte</h4>
        <div class="corridor" i18n="@@standortPage.typ.wohn.corridor">1.800 – 2.700 € / Monat</div>
        <p i18n="@@standortPage.typ.wohn.text">Stark bei dichter Bebauung und schlechter Nahversorgung.</p></div>
      <div class="type"><span class="tag hi" i18n="@@standortPage.tag.sehrGut2">Sehr gut</span><h4 i18n="@@standortPage.typ.camping">Campingplatz / Tourismus</h4>
        <div class="corridor" i18n="@@standortPage.typ.camping.corridor">2.800 – 4.300 € / Monat (saisonal)</div>
        <p i18n="@@standortPage.typ.camping.text">In der Saison herausragend – Gäste kennen keine Alternative.</p></div>
      <div class="type"><span class="tag hi" i18n="@@standortPage.tag.sehrGut3">Sehr gut</span><h4 i18n="@@standortPage.typ.tank">Tankstelle / Rastplatz</h4>
        <div class="corridor" i18n="@@standortPage.typ.tank.corridor">2.600 – 3.900 € / Monat</div>
        <p i18n="@@standortPage.typ.tank.text">Vorhandener Halt-Anlass. Ideal mit ergänzender Ware statt Konkurrenz zum Shop.</p></div>
      <div class="type"><span class="tag mid" i18n="@@standortPage.tag.solide3">Solide</span><h4 i18n="@@standortPage.typ.verein">Vereinsheim / Dorfzentrum</h4>
        <div class="corridor" i18n="@@standortPage.typ.verein.corridor">1.400 – 2.100 € / Monat</div>
        <p i18n="@@standortPage.typ.verein.text">Community-Effekt, wenig Wettbewerb; schwankt mit Veranstaltungen.</p></div>
      <div class="type"><span class="tag lo" i18n="@@standortPage.tag.kritisch">Kritisch</span><h4 i18n="@@standortPage.typ.gewerbe">Gewerbegebiet</h4>
        <div class="corridor" i18n="@@standortPage.typ.gewerbe.corridor">700 – 1.100 € / Monat</div>
        <p i18n="@@standortPage.typ.gewerbe.text">Nur werktags Frequenz. Funktioniert mit Sortiment für Pendler.</p></div>
      <div class="type"><span class="tag lo" i18n="@@standortPage.tag.pruefen">Prüfen</span><h4 i18n="@@standortPage.typ.hauptstrasse">Hauptstraße ohne Halt</h4>
        <div class="corridor" i18n="@@standortPage.typ.hauptstrasse.corridor">450 – 700 € / Monat</div>
        <p i18n="@@standortPage.typ.hauptstrasse.text">Viel Verkehr, aber niemand hält an. Vorbeifahren ist kein Kaufen.</p></div>
    </div>
    <div class="note" i18n="@@standortPage.sec2.note">
      <strong>Woher die Zahlen kommen:</strong> Grundlage sind die ersten 450 marktbox-Automaten –
      Flottendurchschnitt rund <strong>2.080 € netto/Monat</strong>, die meisten zwischen 600 und 4.800 €.
      Kosten, Marge und Break-even rechnet der Rechner mit demselben Modell wie der Amortisationsrechner.
    </div>
  </div>
</section>

<section class="band band--white" id="filiale">
  <div class="wrap">
    <p class="sec-label"><span class="n">03</span> <ng-container i18n="@@standortPage.sec3.label">Sonderfall</ng-container></p>
    <h2 i18n="@@standortPage.sec3.h2">Ein Automat vor dem eigenen Laden</h2>
    <div class="prose">
      <p i18n="@@standortPage.sec3.p1">Viele Bäckereien und Hofläden stellen die marktbox vor die eigene Filiale. Tatsächlich ist das
        ein <strong>anderes Produkt</strong>: Verdienen kann der Automat nur <strong>außerhalb der
        Ladenzeiten</strong> – sonntagmorgens, abends, an Feiertagen.</p>
    </div>
    <div class="tblwrap">
      <table class="cmp">
        <thead><tr><th></th><th i18n="@@standortPage.cmp.th1">Vor der Filiale</th><th i18n="@@standortPage.cmp.th2">Freier Standort ohne Supermarkt</th></tr></thead>
        <tbody>
          <tr><th scope="row" i18n="@@standortPage.cmp.zweck">Zweck</th><td i18n="@@standortPage.cmp.zweck.a">Öffnungszeiten erweitern</td><td i18n="@@standortPage.cmp.zweck.b">Versorgungslücke schließen</td></tr>
          <tr><th scope="row" i18n="@@standortPage.cmp.konkurrenz">Konkurrenz</th><td i18n="@@standortPage.cmp.konkurrenz.a">der eigene Laden</td><td i18n="@@standortPage.cmp.konkurrenz.b">keine im Umkreis</td></tr>
          <tr><th scope="row" i18n="@@standortPage.cmp.fenster">Verkaufsfenster</th><td i18n="@@standortPage.cmp.fenster.a">nur außerhalb der Ladenzeiten</td><td>24/7</td></tr>
          <tr><th scope="row" i18n="@@standortPage.cmp.umsatz">Umsatz</th><td i18n="@@standortPage.cmp.umsatz.a">niedriger, planbar</td><td i18n="@@standortPage.cmp.umsatz.b">deutlich höher</td></tr>
          <tr><th scope="row" i18n="@@standortPage.cmp.modell">Empfohlenes Modell</th><td class="rec" i18n="@@standortPage.cmp.modell.a">Miete</td><td class="rec" i18n="@@standortPage.cmp.modell.b">Kauf</td></tr>
        </tbody>
      </table>
    </div>
    <div class="prose">
      <p i18n="@@standortPage.sec3.p2">Wer vor der Filiale gute Erfahrungen macht, stellt die zweite Box an einen <strong>freien
        Standort im Umland</strong> – und rechnet dort mit dem Zwei- bis Dreifachen. Der Rechner zeigt
        diesen Vergleich direkt an, wenn Sie „Ja, vor einem meiner Geschäfte" wählen.</p>
    </div>
  </div>
</section>

<section class="band" id="faktoren">
  <div class="wrap">
    <p class="sec-label"><span class="n">04</span> <ng-container i18n="@@standortPage.sec4.label">Harte Faktoren</ng-container></p>
    <h2 i18n="@@standortPage.sec4.h2">Wenn die Lücke stimmt, entscheidet der Rest</h2>
    <div class="cards-4">
      <div class="mini"><p class="mk" i18n="@@standortPage.faktor1.mk">Sichtbarkeit</p><h4 i18n="@@standortPage.faktor1.h4">Rechtzeitig erkennbar</h4>
        <p i18n="@@standortPage.faktor1.text">Aus Fahrtrichtung sichtbar, bevor man vorbei ist. Sonst hilft klare Beschilderung mehr als Größe.</p></div>
      <div class="mini"><p class="mk" i18n="@@standortPage.faktor2.mk">Parken &amp; Halten</p><h4 i18n="@@standortPage.faktor2.h4">Kein Halten, kein Kauf</h4>
        <p i18n="@@standortPage.faktor2.text">Ein, zwei Stellplätze direkt am Automaten sind wichtiger als der letzte Meter Sichtbarkeit.</p></div>
      <div class="mini"><p class="mk" i18n="@@standortPage.faktor3.mk">Strom &amp; Licht</p><h4 i18n="@@standortPage.faktor3.h4">230 V und Beleuchtung</h4>
        <p i18n="@@standortPage.faktor3.text">Normaler 230-V-Anschluss. Licht macht den Automaten abends und im Winter nutzbar.</p></div>
      <div class="mini"><p class="mk" i18n="@@standortPage.faktor4.mk">Zufahrt</p><h4 i18n="@@standortPage.faktor4.h4">Einfach erreichbar</h4>
        <p i18n="@@standortPage.faktor4.text">Anfahrt zum Nachfüllen und Zufahrt für Kundschaft unkompliziert – auch mit Anhänger und im Winter.</p></div>
    </div>
  </div>
</section>

<section class="band band--white" id="recht">
  <div class="wrap">
    <p class="sec-label"><span class="n">05</span> <ng-container i18n="@@standortPage.sec5.label">Rechtliches</ng-container></p>
    <h2 i18n="@@standortPage.sec5.h2">Genehmigungen – meist einfacher als gedacht</h2>
    <div class="cards-3">
      <div class="legal"><span class="badge badge-ok" i18n="@@standortPage.recht1.badge">Meist unkompliziert</span><h4 i18n="@@standortPage.recht1.h4">Auf eigenem Grund</h4>
        <p i18n="@@standortPage.recht1.text">Abgesetzt vom öffentlichen Raum gering. Bei baulichen Veränderungen kurz bei der Gemeinde nachfragen.</p></div>
      <div class="legal"><span class="badge badge-mid" i18n="@@standortPage.recht2.badge">Vereinbarung nötig</span><h4 i18n="@@standortPage.recht2.h4">Auf fremdem Grund</h4>
        <p i18n="@@standortPage.recht2.text">Vereinbarung mit dem Eigentümer nötig; je nach Lage zusätzlich eine Genehmigung.</p></div>
      <div class="legal"><span class="badge badge-warn" i18n="@@standortPage.recht3.badge">Ggf. Erlaubnis</span><h4 i18n="@@standortPage.recht3.h4">An öffentlichem Grund</h4>
        <p i18n="@@standortPage.recht3.text">Wirkt der Automat in den Verkehrsraum, kann eine Sondernutzungserlaubnis nötig sein.</p></div>
    </div>
    <div class="note" i18n="@@standortPage.sec5.note"><strong>Faustregel:</strong> Je weiter weg vom öffentlichen Verkehrsraum, desto
      weniger Bürokratie. Zuständigkeit früh klären – selten ein Hindernis, oft ein Grund fürs Aufschieben.</div>
  </div>
</section>

<section class="band" id="finden">
  <div class="wrap">
    <p class="sec-label"><span class="n">06</span> <ng-container i18n="@@standortPage.sec6.label">Standort finden</ng-container></p>
    <h2 i18n="@@standortPage.sec6.h2">Noch keinen Standort? Kein Nein, ein Noch-nicht</h2>
    <div class="steps">
      <div class="step"><div class="num">1</div><div>
        <h4 i18n="@@standortPage.step1.h4">In Versorgungslücken denken, nicht in Adressen</h4>
        <p i18n="@@standortPage.step1.text">Wo endet abends oder sonntags die Nahversorgung? Diese Orte sind Ihre Kandidaten.</p></div></div>
      <div class="step"><div class="num">2</div><div>
        <h4 i18n="@@standortPage.step2.h4">Naheliegende Flächengeber ansprechen</h4>
        <p i18n="@@standortPage.step2.text">Landwirte an Durchgangsstraßen, Tankstellen, Campingplätze, Vereinsheime – alle haben Fläche, Strom und Interesse an Frequenz.</p></div></div>
      <div class="step"><div class="num">3</div><div>
        <h4 i18n="@@standortPage.step3.h4">Das Angebot leicht annehmbar machen</h4>
        <p i18n="@@standortPage.step3.text">Die meisten sagen nicht aus Prinzip nein, sondern weil sie sich nichts vorstellen können. Dafür gibt es den Einseiter.</p></div></div>
    </div>
  </div>
</section>

<section class="band band--white" id="flaeche">
  <div class="wrap">
    <p class="sec-label"><span class="n">07</span> <ng-container i18n="@@standortPage.sec7.label">Flächengeber</ng-container></p>
    <h2 i18n="@@standortPage.sec7.h2">Den Flächeneigentümer überzeugen</h2>
    <div class="prose"><p i18n="@@standortPage.sec7.intro">Wer auf fremder Fläche aufstellen will, muss verhandeln – und die meisten
      haben so ein Gespräch nie geführt. Zwei fertige Dokumente nehmen es Ihnen ab:</p></div>
    <div class="docgrid">
      <div class="doccard"><p class="mk" i18n="@@standortPage.doc1.mk">PDF · zum Hinlegen</p><h4 i18n="@@standortPage.doc1.h4">Flächengeber-Einseiter</h4>
        <p i18n="@@standortPage.doc1.text">Ein Blatt für den Eigentümer – was eine marktbox ist, was er davon hat, Platz, Strom, Optik.</p></div>
      <div class="doccard"><p class="mk" i18n="@@standortPage.doc2.mk">Vorlage</p><h4 i18n="@@standortPage.doc2.h4">Muster-Nutzungsvertrag</h4>
        <p i18n="@@standortPage.doc2.text">Die Vereinbarung zwischen Ihnen und dem Flächengeber, die Sie nur noch ausfüllen.</p></div>
    </div>
    <div class="note" id="downloads" i18n="@@standortPage.sec7.note"><strong>In Vorbereitung:</strong> Diese Downloads stellen wir in
      Kürze bereit. Vorab gewünscht? Schreiben Sie uns kurz – wir schicken sie zu.</div>
  </div>
</section>

<section class="band">
  <div class="wrap">
    <div class="bridge">
      <span i18n="@@standortPage.bridge.text">Tiefer einsteigen, statt nur rechnen? Der ausführliche <strong>Standort-Guide</strong> erklärt
        jeden Standorttyp, das Rechtliche und die Standortsuche im Detail.</span>
      <a class="btn btn--dark" [routerLink]="['/', links.guide, guideLocationPath]" i18n="@@standortPage.bridge.cta">Zum Standort-Guide →</a>
    </div>
  </div>
</section>

<section class="band band--teal" id="kontakt">
  <div class="wrap">
    <div class="final">
      <p class="sec-label"><span class="n">›</span> <ng-container i18n="@@standortPage.kontakt.label">Persönlich</ng-container></p>
      <h2 i18n="@@standortPage.kontakt.h2">Sie haben einen Standort im Blick?</h2>
      <p i18n="@@standortPage.kontakt.text">Dann lassen Sie ihn uns gemeinsam einordnen – ehrlich, was realistisch drin ist, und ob Kauf
        oder Miete besser passt. Und wenn Sie noch keinen Standort haben, helfen wir beim Finden.</p>
      <div class="cta-row">
        <a class="btn" href="#rechner" (click)="scrollToAnchor($event, 'rechner')" i18n="@@standortPage.kontakt.cta1">Standort jetzt einschätzen</a>
        <a class="btn btn--ghost" href="#contact" (click)="scrollToAnchor($event, 'contact')" i18n="@@standortPage.kontakt.cta2">Mit Lukas sprechen</a>
      </div>
    </div>
  </div>
</section>

<section class="band band--white">
  <div class="wrap footer" i18n="@@standortPage.foot">
    Die Umsatzangaben sind Orientierungskorridore und keine Zusicherung. Sie werden fortlaufend mit
    realen Automatendaten kalibriert.
  </div>
</section>
